<main>
    <h1 class="dialog-title dialog-title--bigger" >{{"ChangeStateUser" | translate}}</h1>
    
  
    <mat-dialog-content>
       
        <p>
          ¿{{"ChangeStateUserText" | translate}} <strong>{{user.userName}}</strong> ?
        </p>
    </mat-dialog-content>
    <div *ngIf="ischange">
      <section class="dialog-loading-container">
        <div  class="pulsing">
          <mat-spinner [diameter]="50" ></mat-spinner>
        </div>
        <p class="pulsing">{{"Loading" | translate}}</p>
      </section>
    </div>
  
    <mat-dialog-actions align="center" >
        <button class="dialog__button" (click)="OnCancel()">
          {{"Cancel" | translate}}
          
        </button>
        <button class="dialog__button dialog__button--fill" 
        [disabled]="ischange"
        (click)="OnSave()">
          {{"Accept" | translate}}
        </button>
    </mat-dialog-actions>
    
   
  </main>
  